import React, { useState, useEffect } from "react";
import TextareaAutosize from "react-textarea-autosize";
import CloseIcon from "../assets/icons/close-icon.svg";
import "../styles/components/form.css";

const SocialActivityForm = ({
    onClose,
    onSave,
    initialText = "",
    mode = "create"
}) => {
    const [activityText, setActivityText] = useState(initialText);

    const isFormValid = activityText.trim() !== "";

    const handleSubmit = (e) => {
        e.preventDefault();

        onSave(activityText);
        onClose();
    };

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <div className="modal-overlay">
            <div className="form">
                <div className="form-header">
                    <h1 className="form-title">
                        {mode === "edit" ? "Редактирование пункта" : "Добавление пункта"}
                    </h1>
                    <button className="close-button" onClick={onClose}>
                        <img src={CloseIcon} alt="Закрыть" />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="field-label">Текст пункта</label>
                        <TextareaAutosize
                            className="textarea-input"
                            placeholder="Введите текст пункта"
                            value={activityText}
                            onChange={(e) => setActivityText(e.target.value)}
                            autoFocus
                        />
                    </div>
                    <div className="form-buttons">
                        <button type="button" className="cancel-button" onClick={onClose}>
                            Отменить
                        </button>
                        <button type="submit" className="save-button" disabled={!isFormValid}>
                            Сохранить
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SocialActivityForm;